export default __webpack_public_path__ + "static/media/resume-bg.e591a57d.jpg";